module.exports = __webpack_public_path__ + "static/media/mobile-lostasylum-cover.2767b856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/LA/mobile-lostasylum-cover.jpg
// module id = 766
// module chunks = 1